<template>
  <article>
    <div class="filter mt-20 mb-20">
      <div class="filter__item">
        <adSelect v-model="filters.adid" :lists.sync="adLists"/>
      </div>
      <div class="filter__item">
        <div class="filter__name">运营：</div>
        <operSelect v-model="filters.opid" :lists.sync="operLists"/>
      </div>
      <div class="filter__item">
        <div class="filter__name">品牌：</div>
        <el-input v-model="filters.brand" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">直播间：</div>
        <el-input v-model="filters.live" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">分类：</div>
        <el-input v-model="filters.category" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">口令链接：</div>
        <el-input v-model="filters.keyword" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="ml-auto">
        <button class="blue-small-btn mr-10" @click="uploadDialog = !uploadDialog">上传</button>
      </div>
    </div>
    <el-table ref="dataTable" :data="lists" highlight-current-row v-loading="listLoading" style="width: 100%;" class="" height="600">
      <el-table-column prop="dkid" label="ID" width="" align="center">
      </el-table-column>
      <el-table-column prop="adid" label="广告ID" width="" align="center">
        <template slot-scope="scope">
          <div>{{scope.row.ad_title}}({{scope.row.adid}})</div>
        </template>
      </el-table-column>
      <el-table-column prop="hot" label="热门" width="" align="center">
      </el-table-column>
      <el-table-column prop="brand" label="品牌" width="" align="center">
      </el-table-column>
      <el-table-column prop="live" label="直播间" width="" align="center">
      </el-table-column>
      <el-table-column prop="category" label="分类" width="" align="center">
      </el-table-column>
      <el-table-column prop="min_discount" label="底价折扣" width="" align="center">
      </el-table-column>
      <el-table-column prop="discount" label="折扣" width="" align="center">
      </el-table-column>
      <el-table-column prop="keyword" label="口令" width="" align="center">
      </el-table-column>
      <el-table-column prop="goods" label="店铺信息" width="" align="center">
        <template slot-scope="scope">
          <el-tooltip placement="top" effect="light">
            <div slot="content">
              <div>{{scope.row.goods}}</div>
            </div>
            <el-button size="mini">显示</el-button>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="" label="截止时间" width="" align="center">
        <template slot-scope="scope">
          <div v-html="formatTimeStamp(scope.row.deadline)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="" label="创建时间" width="" align="center">
        <template slot-scope="scope">
          <div v-html="formatTimeStamp(scope.row.create_time)"></div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, pager, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="filters.l" :page-sizes="[20, 50, 80, 100]" :total="filters.total" :current-page="filters.p" class="tac mt-36 pb-36">
    </el-pagination>
    <el-dialog title="上传快团团订单" :visible.sync="uploadDialog" size="tiny" width="600px" center>
      <div class="flex fdc aic">
        <div class="dataForm">
          <div class="dataForm__item">
            <div class="dataForm__name">广告：</div>
            <adSelect v-model="uploadInfo.adid" :lists.sync="adLists"/>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">导入数据：</div>
            <el-upload
              ref="keywordUpload"
              class="upload-demo"
              drag
              action=""
              :limit="1"
              accept=".xls,.xlsx"
              :on-success="uploadSuccess"
              :on-error="uploadError"
              :http-request="dyKeywordUpload"
              >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              <div class="el-upload__tip" slot="tip">只能上传.xls和.xlsx文件</div>
            </el-upload>
          </div>
        </div>
      </div>
    </el-dialog>
  </article>
</template>

<script>
import Clipboard from 'clipboard'
import util from '../../../script/util'
import mixinList from '../../../mixins/list'
import {dyKeywordLists, dyKeywordUpload} from '../../../api/api'
import adSelect from '../../../components/data-select/adSelect.vue'
import operSelect from '../../../components/data-select/operSelect.vue'
export default {
  name: 'keywordList',
  mixins: [mixinList],
  components: {
    adSelect,
    operSelect
  },
  data () {
    return {
      lists: [],
      listLoading: false,
      uploadDialog: false,
      adLists: [],
      operLists: [],
      filters: {
        p: 1,
        l: 20,
        total: 0,
        adid: '',
        opid: '',
        brand: '',
        live: '',
        category: '',
        keyword: '',
        goods: ''
      },
      uploadInfo: {
        'adid': ''
      }
    }
  },
  methods: {
    handleSizeChange (val) {
      this.filters.l = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.filters.p = val
      this.getList()
    },
    // 格式化时间
    formatTimeStamp (time) {
      return util.formatTimeStamp(time)
    },
    uploadSuccess (res) {
      // 去掉文件列表
      this.$refs['keywordUpload'].clearFiles()
    },
    uploadError (res) {
      // 去掉文件列表
      this.$refs['keywordUpload'].clearFiles()
    },
    dyKeywordUpload (params) {
      if (this.uploadInfo.adid === '') {
        this.$notify({
          title: '失败',
          message: '请选择广告',
          type: 'error'
        })
        return
      }

      let file = params.file

      // 使用FormData传参数和文件
      let form = new FormData()

      // 添加键值对
      form.append('file', file)

      form.append('adid', this.uploadInfo.adid)

      dyKeywordUpload(form).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '提交成功',
            type: 'success'
          })
          this.getList()
          this.uploadInfo.adid = ''
          this.uploadDialog = false
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    getList () {
      let filters = this.filters
      let params = {
        p: filters.p,
        l: filters.l
      }

      if (filters.adid !== '') {
        params.adid = filters.adid
      }

      if (filters.brand !== '') {
        params.brand = filters.brand
      }

      if (filters.live !== '') {
        params.live = filters.live
      }

      if (filters.category !== '') {
        params.category = filters.category
      }

      if (filters.keyword !== '') {
        params.keyword = filters.keyword
      }

      if (filters.goods !== '') {
        params.goods = filters.goods
      }

      this.listLoading = true
      dyKeywordLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.lists = data.d.lists
          this.filters.total = data.d.total
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
        this.notifyError('服务器出错了')
      })
    },
    copyLink () {
      let clipboard = new Clipboard('.copy-btn')
      clipboard.on('success', e => {
        this.$notify({
          title: '成功',
          message: '复制成功',
          type: 'success'
        })

        // 释放内存
        clipboard.destroy()
      })

      clipboard.on('error', e => {
        this.$notify({
          title: '失败',
          message: '复制失败',
          type: 'error'
        })

        // 释放内存
        clipboard.destroy()
      })
    },
    filterParamsChange () {
      this.filters.p = 1
      this.getList()
    }
  },
  updated () {
    this.$nextTick(() => {
      this.$refs['dataTable'].doLayout()
      this.$refs['dataTable'].bodyWrapper.scrollTop = 0
    })
  },
  watch: {
    'filters.adid': 'filterParamsChange',
    'filters.opid': 'filterParamsChange',
    'filters.brand': 'filterParamsChange',
    'filters.live': 'filterParamsChange',
    'filters.category': 'filterParamsChange',
    'filters.keyword': 'filterParamsChange',
    'filters.goods': 'filterParamsChange'
  },
  mounted () {
    this.getList()
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/module/ad/keywordList.vue